import {
  getWebsiteMeta,
  idleWebsiteMeta,
  loadingWebsiteMeta,
  getFeaturedPkg,
  getCountriesInfo,
} from "../actions/init";
import { getAddOnDestinations, getPackagesMeta } from "../actions/search";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

export const MetaFetcherHoc = (WrappedComponent) => {
  class Comp extends React.Component {
    async componentDidMount() {
      const {
        getMeta,
        loadingWeb,
        idleWeb,
        getDestinations,
        getPkgMeta,
        getFeatPkg,
        get_countries_info,
      } = this.props;

      loadingWeb();
      await getMeta();
      getDestinations();
      await getPkgMeta();
      getFeatPkg();
      get_countries_info();
      idleWeb();
    }
    render() {
      const { loading, currency } = this.props;

      return <WrappedComponent loading={loading} currency={currency} />;
    }
  }

  Comp.propTypes = {
    loading: PropTypes.bool.isRequired,
    currency: PropTypes.string.isRequired,
    getMeta: PropTypes.func.isRequired,
    loadingWeb: PropTypes.func.isRequired,
    idleWeb: PropTypes.func.isRequired,
    getDestinations: PropTypes.func.isRequired,
    getPkgMeta: PropTypes.func.isRequired,
    getFeatPkg: PropTypes.func.isRequired,
    get_countries_info: PropTypes.func.isRequired,
  };

  const mapStateToProps = (state) => {
    const { loading } = state.WebsiteMetadata;

    const currencyMeta = _.get(state.WebsiteMetadata, "metadata.currency", "");
    const currenciesMeta = _.get(
      state.WebsiteMetadata,
      "metadata.currencies",
      []
    );
    const currency =
      currenciesMeta.length > 0 ? currenciesMeta[0] : currencyMeta;

    return {
      loading,
      currency,
    };
  };

  const mapDispatchToProps = (dispatch) => {
    return {
      getMeta: () => dispatch(getWebsiteMeta()),
      loadingWeb: () => dispatch(loadingWebsiteMeta()),
      idleWeb: () => dispatch(idleWebsiteMeta()),
      getDestinations: () => dispatch(getAddOnDestinations()),
      getPkgMeta: () => dispatch(getPackagesMeta()),
      getFeatPkg: () => dispatch(getFeaturedPkg()),
      get_countries_info: () => dispatch(getCountriesInfo()),
    };
  };

  return connect(mapStateToProps, mapDispatchToProps)(Comp);
};
